import React from 'react';
import PropTypes from 'prop-types';
import questionCss from './Questions.scss'
import css from './LongTextField.scss'
import Icon from 'SF/MaterialIcon';
import { omit } from 'lodash'

export default class LongTextField extends React.Component {

  getEditableField = (inputProps, questionText) => {
    const { value } = inputProps
    return (
      <div className={css['textarea-wrapper']} >
        <textarea
          {...omit(inputProps, 'setValue', 'setHasError', 'questionNumber')}
          type="text"
          aria-label={questionText}
          onChange={this.changeHandler}
          value={value || ''}
        />
      </div>
    );
  }

  renderEmptyAnswerBlock = () => {
    return (
      <i>No answer provided</i>
    );
  }

  renderMultiLineValue = (value) => {
    if(!value) return null;
    return value.replace(/\r\n/g, '\n').split('\n').map((line, i) => <span key={i}>{line}</span>)
  }

  getReadOnlyField = (value) => {
    return (
      <p className={css['long-text-answers']}>{this.renderMultiLineValue(value) || this.renderEmptyAnswerBlock()}</p>
    );
  }

  changeHandler = (e) => {
    this.props.setValue(e.target.value)
  }

  render() {
    const { isReadOnly, hasError, questionText, ...rest } = this.props;
    const questionErrorClassName = hasError ? css['error'] : '';
    return (
      <>
        <div className={`${questionErrorClassName}`}>
          {isReadOnly ? this.getReadOnlyField(rest.value) : this.getEditableField(rest, questionText)}
        </div>
        {!isReadOnly && hasError && (
          <div className={questionCss['input-error-message-block']} role="alert">
            <Icon icon="error" /><p>Invalid response</p>
          </div>
        )}
      </>
    );
  }
}

LongTextField.propTypes = {
  value: PropTypes.string,
  questionText: PropTypes.string,
  isReadOnly: PropTypes.bool,
  hasError: PropTypes.bool,
  setValue: PropTypes.func
}
